import { rateLimitedFetchAuthSession } from "../fetchAuthSession";

export function createApiFetch() {
	return async <O>(path: string, method: string, body?: any) => {
		const session = await rateLimitedFetchAuthSession();

		return fetch(`${import.meta.env.VITE_API_URL}${path}`, {
			method: method,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${session.tokens?.accessToken.toString()}`,
			},
			body: body ? JSON.stringify(body) : undefined,
		})
			.then((res) => {
				if (res.status === 200) {
					return res.json() as Promise<O>;
				}
				throw new Error(`${res.status} ${res.statusText}`);
			})
			.catch((err) => {
				console.error(err);
				throw err;
			});
	};
}

export const apiFetch = createApiFetch();
